import React from "react";
import { BrowserRouter as Router, Route, useParams } from "react-router-dom";
import "./App.css";

import Header from "./components/Header";
import Nav from "./components/Nav";
import Productos from "./components/Productos";
import ProductoItem from "./components/ProductoItem";
//import Carousel from "./components/Swiper";
import Novedades from "./components/Novedades";
import Oferta from "./components/Oferta";
import Marcas from "./components/Marcas";
/*import Newsletter from "./components/NewsLetter";*/
import Footer from "./components/Footer";
import Servicios from "./components/Servicios";
import Nosotros from "./components/Nosotros";
import Contacto from "./components/Contacto";
import Busqueda from "./components/Busqueda";
import Banner from "./components/Nosotros/Banner";

const ItemsData = [
  /*{data: [
      { id: "1", nombreCategoria: "Aires Acondicionados" },
      { id: "2", nombreCategoria: "Heladeras" },
      { id: "3", nombreCategoria: "Lavarropas" },
      { id: "4", nombreCategoria: "Herramientas" },
      { id: "5", nombreCategoria: "Combos" },
    ],
  },*/

  {
    id: "1",
    nombre: "Caño De Cobre 1/4 Aire Refrigeración Rollo De 15 Metros",
    precio: "",
    imgUrl:
      "https://http2.mlstatic.com/D_NQ_NP_663546-MLA44781728623_022021-O.webp",
    categoriaId: "Aires Acondicionados",
    novedades: "0", // "1" para true "0" para false
    oferta: "1", // "1" para true "0" para false
    url:
      "https://articulo.mercadolibre.com.ar/MLA-906788100-cano-de-cobre-14-aire-refrigeracion-rollo-de-15-metros-_JM",
    descripcionItem:
      "CAÑO DE COBRE DE REFRIGERACION PARA AIRE ACONDICIONADO - ROLLO DE 15 METROS 1/4",
  },
  {
    id: "2",
    nombre: "Aislacion 1/4 Caño De Cobre Aire Acondicionado",
    precio: "",
    imgUrl:
      "https://http2.mlstatic.com/D_NQ_NP_870655-MLA44656575495_012021-O.webp",
    categoriaId: "Aires Acondicionados",
    novedades: "0", // "1" para true "0" para false
    oferta: "1", // "1" para true "0" para false
    url:
      "https://articulo.mercadolibre.com.ar/MLA-905062143-aislacion-14-cano-de-cobre-aire-acondicionado-_JM",
    descripcionItem:
      "*PRECIO PROMOCIONAL POR APERTURA* - Aislacion Goma 1/4 x 2 metros para cañeria de cobre refrigeracion",
  },
  {
    id: "3",
    nombre: "Cinta Blanca Sin Adhesivo Aire Acondicionado Refrig Tacsa",
    precio: "",
    imgUrl:
      "https://http2.mlstatic.com/D_NQ_NP_935519-MLA44840196376_022021-O.webp",
    categoriaId: "Aires Acondicionados",
    novedades: "1",
    oferta: "1",
  },
  {
    id: "4",
    nombre: "Aislacion 1/4 Caño De Cobre Aire Acondicionado",
    precio: "",
    imgUrl:
      "https://http2.mlstatic.com/D_NQ_NP_870655-MLA44656575495_012021-O.webp",
    categoriaId: "Aires Acondicionados",
    novedades: "0", // "1" para true "0" para false
    oferta: "1", // "1" para true "0" para false
    url:
      "https://articulo.mercadolibre.com.ar/MLA-905036999-cinta-blanca-sin-adhesivo-aire-acondicionado-refrig-tacsa-_JM",
    descripcionItem:
      "*PRECIO PROMOCIONAL POR APERTURA* - 1 Cinta blanca sin adhesivo PVC TACSA 20 METROS.",
  },
  {
    id: "5",
    nombre: "Aislacion 3/8 Caño De Cobre Aire Acondicionado",
    precio: "",
    imgUrl:
      "https://http2.mlstatic.com/D_NQ_NP_870655-MLA44656575495_012021-O.webp",
    categoriaId: "Aires Acondicionados",
    novedades: "0", // "1" para true "0" para false
    oferta: "1", // "1" para true "0" para false
    url:
      "https://articulo.mercadolibre.com.ar/MLA-905997053-aislacion-38-cano-de-cobre-aire-acondicionado-_JM",
    descripcionItem:
      "*PRECIO PROMOCIONAL POR APERTURA* - Aislacion Goma 3/8 x 2 metros para cañeria de cobre refrigeracion.",
  },
  {
    id: "6",
    nombre: "Caño De Cobre 5/8 Aire Refrigeración Por Metro",
    precio: "",
    imgUrl:
      "https://http2.mlstatic.com/D_NQ_NP_663546-MLA44781728623_022021-O.webp",
    categoriaId: "Aires Acondicionados",
    novedades: "0", // "1" para true "0" para false
    oferta: "1", // "1" para true "0" para false
    url:
      "https://articulo.mercadolibre.com.ar/MLA-905997053-aislacion-38-cano-de-cobre-aire-acondicionado-_JM",
    descripcionItem:
      "*PRECIO PROMOCIONAL POR APERTURA* - CAÑO DE COBRE DE REFRIGERACION PARA AIRE ACONDICIONADO - POR METRO 5/8",
  },
  {
    id: "7",
    nombre: "Caño De Cobre 3/8 Aire Refrigeración Rollo De 15 Metros",
    precio: "",
    imgUrl:
      "https://http2.mlstatic.com/D_NQ_NP_663546-MLA44781728623_022021-O.webp",
    categoriaId: "Aires Acondicionados",
    novedades: "0", // "1" para true "0" para false
    oferta: "1", // "1" para true "0" para false
    url:
      "https://articulo.mercadolibre.com.ar/MLA-906790340-cano-de-cobre-38-aire-refrigeracion-rollo-de-15-metros-_JM",
    descripcionItem:
      "*PRECIO PROMOCIONAL POR APERTURA* - CAÑO DE COBRE DE REFRIGERACION PARA AIRE ACONDICIONADO - ROLLO DE 15 METROS 3/8",
  },
  {
    id: "8",
    nombre: "Caño De Cobre 5/8 Aire Refrigeración Rollo De 15 Metros",
    precio: "",
    imgUrl:
      "https://http2.mlstatic.com/D_NQ_NP_663546-MLA44781728623_022021-O.webp",
    categoriaId: "Aires Acondicionados",
    novedades: "0", // "1" para true "0" para false
    oferta: "1", // "1" para true "0" para false
    url:
      "https://articulo.mercadolibre.com.ar/MLA-906790340-cano-de-cobre-38-aire-refrigeracion-rollo-de-15-metros-_JM",
    descripcionItem:
      "*PRECIO PROMOCIONAL POR APERTURA* - CAÑO DE COBRE DE REFRIGERACION PARA AIRE ACONDICIONADO - ROLLO DE 15 METROS 3/8",
  },
  {
    id: "9",
    nombre: "Caño De Cobre 3/8 Aire Refrigeración Rollo De 15 Metros",
    precio: "",
    imgUrl:
      "https://http2.mlstatic.com/D_NQ_NP_663546-MLA44781728623_022021-O.webp",
    categoriaId: "Aires Acondicionados",
    novedades: "0", // "1" para true "0" para false
    oferta: "1", // "1" para true "0" para false
    url:
      "https://articulo.mercadolibre.com.ar/MLA-906790340-cano-de-cobre-38-aire-refrigeracion-rollo-de-15-metros-_JM",
    descripcionItem:
      "*PRECIO PROMOCIONAL POR APERTURA* - CAÑO DE COBRE DE REFRIGERACION PARA AIRE ACONDICIONADO - ROLLO DE 15 METROS 3/8",
  },
  {
    id: "10",
    nombre: "Cinta Blanca Con Adhesivo Aire Acondicionado Refrig Tacsa",
    precio: "",
    imgUrl:
      "https://http2.mlstatic.com/D_NQ_NP_823220-MLA44837876544_022021-O.webp",
    categoriaId: "Aires Acondicionados",
    novedades: "0", // "1" para true "0" para false
    oferta: "1", // "1" para true "0" para false
    url:
      "https://articulo.mercadolibre.com.ar/MLA-907611377-cinta-blanca-con-adhesivo-aire-acondicionado-refrig-tacsa-_JM",
    descripcionItem:
      "*PRECIO PROMOCIONAL POR APERTURA* - 1 Cinta blanca con adhesivo PVC 18 METROS",
  },
  {
    id: "11",
    nombre: "Aislacion 1/2 Caño De Cobre Aire Acondicionado",
    precio: "",
    imgUrl:
      "https://http2.mlstatic.com/D_NQ_NP_870655-MLA44656575495_012021-O.webp",
    categoriaId: "Aires Acondicionados",
    novedades: "0", // "1" para true "0" para false
    oferta: "1", // "1" para true "0" para false
    url:
      "https://articulo.mercadolibre.com.ar/MLA-906782912-aislacion-12-cano-de-cobre-aire-acondicionado-_JM",
    descripcionItem:
      "*PRECIO PROMOCIONAL POR APERTURA* - Aislacion Goma 1/2 x 2 metros para cañeria de cobre refrigeracion",
  },
  {
    id: "12",
    nombre: "Caño De Cobre 5/8 Aire Refrigeración Rollo De 15 Metros",
    precio: "",
    imgUrl:
      "https://http2.mlstatic.com/D_NQ_NP_663546-MLA44781728623_022021-O.webp",
    categoriaId: "Aires Acondicionados",
    novedades: "0", // "1" para true "0" para false
    oferta: "1", // "1" para true "0" para false
    url:
      "https://articulo.mercadolibre.com.ar/MLA-906789695-cano-de-cobre-58-aire-refrigeracion-rollo-de-15-metros-_JM",
    descripcionItem:
      "*PRECIO PROMOCIONAL POR APERTURA* - CAÑO DE COBRE DE REFRIGERACION PARA AIRE ACONDICIONADO - ROLLO DE 15 METROS 5/8",
  },
  {
    id: "13",
    nombre: "Caño De Cobre 1/2 Aire Refrigeración Rollo De 15 Metros",
    precio: "",
    imgUrl:
      "https://http2.mlstatic.com/D_NQ_NP_663546-MLA44781728623_022021-O.webp",
    categoriaId: "Aires Acondicionados",
    novedades: "0", // "1" para true "0" para false
    oferta: "1", // "1" para true "0" para false
    url:
      "https://articulo.mercadolibre.com.ar/MLA-906790488-cano-de-cobre-12-aire-refrigeracion-rollo-de-15-metros-_JM",
    descripcionItem:
      "*PRECIO PROMOCIONAL POR APERTURA* - CAÑO DE COBRE DE REFRIGERACION PARA AIRE ACONDICIONADO - ROLLO DE 15 METROS 1/2",
  },
  {
    id: "14",
    nombre: "Caño De Cobre 1/4 Aire Refrigeración Por Metro",
    precio: "",
    imgUrl:
      "https://http2.mlstatic.com/D_NQ_NP_663546-MLA44781728623_022021-O.webp",
    categoriaId: "Aires Acondicionados",
    novedades: "0", // "1" para true "0" para false
    oferta: "1", // "1" para true "0" para false
    url:
      "https://articulo.mercadolibre.com.ar/MLA-907246841-cano-de-cobre-14-aire-refrigeracion-por-metro-_JM",
    descripcionItem:
      "*PRECIO PROMOCIONAL POR APERTURA* - CAÑO DE COBRE DE REFRIGERACION PARA AIRE ACONDICIONADO - POR METRO 1/4",
  },
  {
    id: "15",
    nombre: "Caño De Cobre 3/8 Aire Refrigeración Por Metro",
    precio: "",
    imgUrl:
      "https://http2.mlstatic.com/D_NQ_NP_663546-MLA44781728623_022021-O.webp",
    categoriaId: "Aires Acondicionados",
    novedades: "0", // "1" para true "0" para false
    oferta: "1", // "1" para true "0" para false
    url:
      "https://articulo.mercadolibre.com.ar/MLA-907286968-cano-de-cobre-38-aire-refrigeracion-por-metro-_JM",
    descripcionItem:
      "*PRECIO PROMOCIONAL POR APERTURA* - CAÑO DE COBRE DE REFRIGERACION PARA AIRE ACONDICIONADO - POR METRO 3/8",
  },
  {
    id: "16",
    nombre: "Calefactor Gas Central Conductos Goodman Gmp 125 28750 Kcalh",
    precio: "",
    imgUrl:
      "https://http2.mlstatic.com/D_NQ_NP_704839-MLA45601198226_042021-O.webp",
    categoriaId: "Aires Acondicionados",
    novedades: "0", // "1" para true "0" para false
    oferta: "1", // "1" para true "0" para false
    url:
      "https://articulo.mercadolibre.com.ar/MLA-916605094-calefactor-gas-central-conductos-goodman-gmp-125-28750-kcalh-_JM",
    descripcionItem:
      "*PRECIO PROMOCIONAL POR APERTURA* - CALEFACTOR GOODMAN GMP 125-52 - Gas Natural - Potencia: 29000 kcal/h - Superficie aprox.: 160 m2 - m2 variable de acuerdo a geolocalización, aislación térmica, cargas térmicas - Medidas: Alto: 84,7 cm Ancho: 53,3 cm Prof.: 71,12 cm Peso: 74 kg",
  },
  {
    id: "17",
    nombre: "Calefactor Gas Central Conductos Goodman Gmp 150 34500 Kcalh",
    precio: "",
    imgUrl:
      "https://http2.mlstatic.com/D_NQ_NP_704839-MLA45601198226_042021-O.webp",
    categoriaId: "Aires Acondicionados",
    novedades: "0", // "1" para true "0" para false
    oferta: "1", // "1" para true "0" para false
    url:
      "https://articulo.mercadolibre.com.ar/MLA-916605213-calefactor-gas-central-conductos-goodman-gmp-150-34500-kcalh-_JM",
    descripcionItem:
      "*PRECIO PROMOCIONAL POR APERTURA* - CALEFACTOR GOODMAN GMP 150-52 - Gas Natural Potencia: 34500 kcal/h Superficie aprox.: 200m2 (variable de acuerdo a geolocalización, aislacion térmica, cargas térmicas Medidas: Alto: 84,7 cm Ancho: 62,2 cm Prof.: 71,12 cm Peso: 78 kg",
  },
  {
    id: "18",
    nombre: "Calefactor Gas Central Conductos Goodman Gmp 100 23500 Kcalh",
    precio: "",
    imgUrl:
      "https://http2.mlstatic.com/D_NQ_NP_704839-MLA45601198226_042021-O.webp",
    categoriaId: "Aires Acondicionados",
    novedades: "0", // "1" para true "0" para false
    oferta: "1", // "1" para true "0" para false
    url:
      "https://articulo.mercadolibre.com.ar/MLA-916605834-calefactor-gas-central-conductos-goodman-gmp-100-23500-kcalh-_JM",
    descripcionItem:
      "*PRECIO PROMOCIONAL POR APERTURA* - Gas Natural Potencia: 23500 kcal/h Superficie aprox.: 130 m2 - variable de acuerdo a geolocalización, aislación térmica, cargas térmicas Medidas: Alto: 84,7 cm Ancho: 44,5 cm Prof.: 71,12 cm Peso: 69 kg",
  },
  {
    id: "19",
    nombre: "Calefactor Gas Central Conductos Goodman Gmp 075 17000 Kcalh",
    precio: "",
    imgUrl:
      "https://http2.mlstatic.com/D_NQ_NP_704839-MLA45601198226_042021-O.webp",
    categoriaId: "Aires Acondicionados",
    novedades: "0", // "1" para true "0" para false
    oferta: "1", // "1" para true "0" para false
    url:
      "https://articulo.mercadolibre.com.ar/MLA-916639960-calefactor-gas-central-conductos-goodman-gmp-075-17000-kcalh-_JM",
    descripcionItem:
      "*PRECIO PROMOCIONAL POR APERTURA* - CALEFACTOR GOODMAN GMP 072-32 Gas Natural Potencia: 17000 kcal/h Superficie aprox.: 95 m2 - variable de acuerdo a geolocalización, aislación térmica, cargas térmicas Medidas: Alto: 84,7 cm Ancho: 35,6 cm Prof.: 71,12 cm Peso: 59 kg",
  },
  {
    id: "20",
    nombre: "Split Pared Bgh Cooltime 4500 Frig Frio Calor",
    precio: "",
    imgUrl:
      "https://http2.mlstatic.com/D_NQ_NP_984422-MLA45608926030_042021-O.webp",
    categoriaId: "Aires Acondicionados",
    novedades: "0", // "1" para true "0" para false
    oferta: "1", // "1" para true "0" para false
    url:
      "https://articulo.mercadolibre.com.ar/MLA-916720065-split-pared-bgh-cooltime-4500-frig-frio-calor-_JM",
    descripcionItem: "*PRECIO PROMOCIONAL POR APERTURA* - 6 CUOTAS SIN INTERES. Capacidad Nom. (W): FRIO - 5200 / CALOR - 5200 - Eficiencia Energetica:FRIO:A / CALOR:C - Medidas de caños (alta - baja ): 1/4 - 1/2 ",
  },
  {
    id: "21",
    nombre: "Split Pared Bgh Cooltime 2300 Frig Frio Calor",
    precio: "",
    imgUrl:
      "https://http2.mlstatic.com/D_NQ_NP_715775-MLA45608922927_042021-O.webp",
    categoriaId: "Aires Acondicionados",
    novedades: "0", // "1" para true "0" para false
    oferta: "1", // "1" para true "0" para false
    url:
      "https://articulo.mercadolibre.com.ar/MLA-916720066-split-pared-bgh-cooltime-2300-frig-frio-calor-_JM",
    descripcionItem: "*PRECIO PROMOCIONAL POR APERTURA* - Capacidad Nom. (W): FRIO 2700 / CALOR - 2650 - Eficiencia Energetica:FRIO:A / CALOR:C - Medidas de caños (alta - baja ): 1/4 - 3/8 ",
  },
  {
    id: "22",
    nombre: "Split Pared Bgh Cooltime 4500 Frig Frio Calor",
    precio: "",
    imgUrl:
      "https://http2.mlstatic.com/D_NQ_NP_965878-MLA45608922929_042021-O.webp",
    categoriaId: "Aires Acondicionados",
    novedades: "0", // "1" para true "0" para false
    oferta: "1", // "1" para true "0" para false
    url:
      "https://articulo.mercadolibre.com.ar/MLA-916720067-split-pared-bgh-cooltime-4500-frig-frio-calor-_JM",
    descripcionItem: "*PRECIO PROMOCIONAL POR APERTURA* - Capacidad Nom. (W): FRIO - 5200 / CALOR - 5200 - Eficiencia Energetica:FRIO:A / CALOR:C - Medidas de caños (alta - baja ): 1/4 - 3/8 ",
  },
  {
    id: "23",
    nombre: "Split Pared Bgh Cooltime 2300 Frig Frio Calor",
    precio: "",
    imgUrl:
      "https://http2.mlstatic.com/D_NQ_NP_610238-MLA45608925131_042021-O.webp",
    categoriaId: "Aires Acondicionados",
    novedades: "0", // "1" para true "0" para false
    oferta: "1", // "1" para true "0" para false
    url:
      "https://articulo.mercadolibre.com.ar/MLA-916720068-split-pared-bgh-cooltime-2300-frig-frio-calor-_JM",
    descripcionItem: "*PRECIO PROMOCIONAL POR APERTURA* - 6 CUOTAS SIN INTERES. Capacidad Nom. (W): FRIO 2700 / CALOR - 2650 - Eficiencia Energetica:FRIO:A / CALOR:C - Medidas de caños (alta - baja ): 1/4 - 3/8 ",
  },
];

const App = () => {
  /*const [itemsLista, setitemsLista] = useState([]);
  useEffect(() => {
    fetch("http://localhost:9000/db")
      .then((res) => res.json())
      .then((res) => setitemsLista(res))
      .catch((err) => err);
  }, []);*/
  const itemsLista = ItemsData; //Hardcoded regrigo's ItemsDatabase here. I know this is horrible >:(

  const Interna = ({ itemsLista }) => {
    const { id } = useParams();
    //eslint-disable-next-line
    const producto = itemsLista.filter((itemSelec) => itemSelec.id == id); // Por Resolver => (Expected '===' and instead saw '==')
    if (!producto || !producto.length) return null;

    return <ProductoItem lista={producto} />;
  };

  return (
    <div className="App">
      <Router>
        <Header />
        <Nav />
        <Route
          exact
          path="/"
          render={() => (
            <React.Fragment>
              {/*<Carousel />*/}
              <Banner />
              <Novedades novedades={itemsLista} />
              <Oferta oferta={itemsLista} />
              <Servicios />
              <Nosotros />
              <Contacto />
              <Marcas />
              {/*<Newsletter />*/}
            </React.Fragment>
          )}
        />
        <Route
          exact
          path="/catalogo"
          render={() => <Productos lista={itemsLista} />}
        />
        <Route path="/catalogo/:id">
          <Interna itemsLista={itemsLista} />
        </Route>
        <Route path="/buscar/:termino">
          <Busqueda itemsLista={itemsLista} />
        </Route>
        <Route path="/servicios" component={Servicios} />
        <Route path="/nosotros" component={Nosotros} />
        <Route path="/contacto" component={Contacto} />
        <Footer />
      </Router>
    </div>
  );
};
export default App;
